"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuerySearchExtraReducers = void 0;
const tslib_1 = require("tslib");
const services_1 = tslib_1.__importDefault(require("../../../services"));
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getItemsPayload_1 = require("../../../shared/getItemsPayload");
const objects_1 = require("../../../utils/objects");
const getIncludesParams_1 = require("../../../shared/getIncludesParams");
const getQuerySearch = toolkitRaw.createAsyncThunk('search/query_items', async (paramsProps, { rejectWithValue }) => {
    try {
        const params = (0, objects_1.renameObjectKey)(paramsProps, {
            locationLatitude: 'latitude',
            locationLongitude: 'longitude',
        });
        if (!Object.keys(params).includes('q')) {
            params.q = '';
        }
        params.includes = (0, getIncludesParams_1.getDefaultIncludesParams)('market_search');
        const response = await services_1.default.get('/api/market/items/search', { params });
        const responseDeserialize = (0, getItemsPayload_1.getQuerySearchDeserializeFromApi)(response);
        return responseDeserialize;
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const getQuerySearchExtraReducers = (builder) => {
    builder.addCase(getQuerySearch.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getQuerySearch.fulfilled, (state, action) => {
        var _a, _b;
        state.loading = false;
        state.error = false;
        if (((_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.offset) > 0) {
            const newData = [...state.data, ...action.payload.data];
            state.data = newData;
        }
        else {
            state.data = action.payload.data;
        }
        state.meta = { ...action.payload.meta };
    });
    builder.addCase(getQuerySearch.rejected, (state) => {
        state.loading = false;
        state.error = true;
    });
};
exports.getQuerySearchExtraReducers = getQuerySearchExtraReducers;
exports.default = getQuerySearch;
//# sourceMappingURL=index.js.map